var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "main-layout",
    [
      _c("div", { staticClass: "container azSize has-text-centered" }, [
        _c(
          "div",
          {
            staticClass:
              "top20 is-size-2 isPoppins has-text-dark  underline  has-text-centered kirvy"
          },
          [_vm._v("Videos")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "has-text-centered top60" }, [
          _c(
            "div",
            {
              staticClass: "is-inline-block videoTrig has-text-right",
              on: {
                click: function($event) {
                  return _vm.openVideo(
                    "https://content.jwplatform.com/videos/O8J8HzLF-ZwDaX2fG.mp4"
                  )
                }
              }
            },
            [
              _c("i", {
                staticClass: "fa fa-play-circle fa-4x has-text-primary"
              }),
              _c("br"),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "is-size-5 has-text-primary videoLabel",
                  staticStyle: { "z-index": "5" }
                },
                [_c("b", [_vm._v("What is Slink?")])]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "is-inline-block videoTrig2 has-text-right",
              on: {
                click: function($event) {
                  return _vm.openVideo(
                    "https://content.jwplatform.com/videos/WUIYAZp9-ZwDaX2fG.mp4"
                  )
                }
              }
            },
            [
              _c("i", {
                staticClass: "fa fa-play-circle fa-4x has-text-primary"
              }),
              _c("br"),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "is-size-5 has-text-primary videoLabel",
                  staticStyle: { "z-index": "5" }
                },
                [_c("b", [_vm._v("A Use Case")])]
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "has-text-centered top60 is-size-3 " }, [
          _c("div", { staticClass: "alterHeading has-background-primary" }, [
            _c("b", { staticClass: "isPoppins " }, [
              _vm._v("No one will ever forget how to find you!")
            ])
          ]),
          _c("br"),
          _vm._v(" "),
          _c("img", {
            staticClass: "top20",
            attrs: {
              src: require("@/assets/img/ownyourwordsyellow.png"),
              width: "200"
            }
          })
        ]),
        _vm._v(" "),
        _c("br"),
        _c("br")
      ]),
      _vm._v(" "),
      _vm.videoOpen ? _c("video1") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b7b48a08", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7b48a08","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Videos.vue
// module id = null
// module chunks = 